import { DataIcon, Download02Icon, Rows01Icon } from "@/icons";
import { FormattedMessage, FormattedNumber, FormattedPlural } from "react-intl";
import { graphql, useFragment } from "react-relay";
import { DatasetAnalyticsFragment$key } from "./__generated__/DatasetAnalyticsFragment.graphql";
import { FormattedDataSize } from "./FormattedDataSize";
import { PropsWithChildren } from "react";

const DatasetAnalyticsFragment = graphql`
  fragment DatasetAnalyticsFragment on DatasetAnalytics {
    rowCount
    fileSize
    downloadCount
  }
`;

interface Props extends PropsWithChildren {
  analytics: DatasetAnalyticsFragment$key;
}

export function DatasetAnalytics(props: Props) {
  const { rowCount, fileSize, downloadCount } = useFragment(
    DatasetAnalyticsFragment,
    props.analytics,
  );
  return (
    <div className="flex flex-col gap-5">
      <p className="text-sm font-semibold text-grey-700">
        <FormattedMessage defaultMessage="Stats" />
      </p>
      <div className="flex flex-col items-start gap-2">
        <div className="flex flex-row items-center gap-2">
          <Download02Icon className="w-5 h-5 text-grey-500" />
          <p className="text-sm font-normal leading-5 text-grey-600">
            <FormattedMessage
              defaultMessage="{downloadCount, plural, =1 {# Download} other {# Downloads}}"
              values={{ downloadCount }}
            />
          </p>
        </div>
        <div className="flex flex-row items-center gap-2">
          <DataIcon className="w-5 h-5 text-grey-500" />
          <p className="text-sm font-normal leading-5 text-grey-600">
            <FormattedDataSize bytes={fileSize} />
          </p>
        </div>
        <div className="flex flex-row items-center gap-2">
          <Rows01Icon className="w-5 h-5 text-grey-500" />
          <p className="text-sm font-normal leading-5 text-grey-600">
            <FormattedNumber value={rowCount} notation="compact" />{" "}
            <FormattedPlural value={rowCount} one="row" other="rows" />
          </p>
        </div>
        {props.children}
      </div>
    </div>
  );
}
